import React from "react";
import "../../Styles/certified/situs.css";

export default function Finzly() {
  return (
    <>
      <div className="situs-certified-details-section">
        <div className="situs-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="situs-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="situs-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="situs-certified-badge"
            />
            <div className="situs-certified-company-names">
              <a href="https://www.situsamc.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/situs/situs.png"
                alt="Walkzero Logo"
                className="situs-certified-company-logo"
              />
            </a>
              <h1 className="situs-certified-full-name">
            SitusAMC India Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="situs-certified-details-right">
            <img
              src="/assets/situs/situs_1.jpg"
              alt="Finzly Office"
              className="situs-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="situs-certified-description">
          <h2>
            Why SitusAMC India Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            We are the leading independent solutions provider to the commercial and residential real estate finance industry. SitusAMC is trusted by the top real estate lenders and investors to support the lifecycle of their commercial and residential real estate activity. We do this through the industry’s most complete end-to-end offering, powering the origination, transaction, management and valuations of real estate debt and equity. We are trusted by top banks, private equity firms, asset managers, residential originators and servicers, CMBS/RMBS issuers, and insurance companies to identify and capture opportunities in their businesses through innovative solutions that drive operational efficiency, increase business effectiveness, and improve market agility. Explore how we can power opportunity in your business

          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="situs-certified-info-cards">
          <div className="situs-certified-info-card">
            <div className="situs-certified-info-title">COMPANY SIZE</div>
            <div className="situs-certified-info-value">2400 Employees</div>
          </div>
          <div className="situs-certified-info-card">
            <div className="situs-certified-info-title">INDUSTRY</div>
            <div className="situs-certified-info-value">Real Estate Services


</div>
          </div>
          <div className="situs-certified-info-card">
            <div className="situs-certified-info-title">CONNECT</div>
            <div className="situs-certified-info-icons">
              <span className="situs-certified-icon-round">
                <a href="https://www.situsamc.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="situs-certified-icon-round">
                <a href="https://www.linkedin.com/company/situsamc/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="situs-certified-icon-round">
                <a href="https://www.facebook.com/situsAMC/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="situs-certified-info-card">
            <div className="situs-certified-info-title">LOCATION (HQ)</div>
            <div className="situs-certified-info-value">Chennai </div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="situs-certified-recognition-section">
          <h2 className="situs-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="situs-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="situs-certified-recognition-image"
            />
          </div>
          <div className="situs-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="situs-certified-life-section">
          <h2 className="situs-certified-life-title">
            Life at SitusAMC India Private Limited
          </h2>
          <div className="situs-certified-life-gallery">
            <div className="situs-certified-life-col">
              <img src="/assets/situs/situs_2.jpg" alt="Office 1" className="situs-certified-life-img" />
              <img src="/assets/situs/situs_3.jpg" alt="Team 1" className="situs-certified-life-img" />
            </div>
            <div className="icom-certified-life-col situs-certified-life-center">
              <img src="/assets/situs/situs_5.png" alt="Main Office" className="situs-certified-life-img situs-certified-life-img-large" />
            </div>
            <div className="situs-certified-life-col">
              <img src="/assets/situs/situs_4.jpeg" alt="Office 2" className="situs-certified-life-img" />
              <img src="/assets/situs/situs_6.jpg" alt="Team 2" className="situs-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
